import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../../../../Helper/Context";
import { ZoneNameCommanDDL } from "../../../../../../../Components/IllegalDDL/ZoneNameCommanDDL";
import { WardNameDDL } from "../../../../../../../Components/IllegalDDL/WardNameDDL";
import { OfficerNameDDL } from "../../../../../../../Components/IllegalDDL/OfficerNameDDL";

const ReturnPopUp = (props) => {


    const { SingleRawID, handleReturn, confirmBtnCallBack, deleteRecord, message, heading, handleIsPost, GridData } = props

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails

    const { t } = useTranslation()

    const [Remark, setRemark] = useState('')
    const [loader, setloader] = useState(false)
    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })

    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [WardNameID, setWardNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [OfficerNameID, setOfficerNameID] = useState({
        DDL: [],
        ID: 0,
        table_M_UserID: 0,
        Label: "Select...",
    })

    const handleAckData = () => {
        setloader(true)
        const data = {
            T_ComplaintDetailsID: GridData.t_ComplaintDetailsID,
            M_ZoneID: ZoneNameID.ID,
            M_WardID: WardNameID.ID,
            Officer_M_UserID: OfficerNameID.table_M_UserID,
            Remark: Remark,
            M_UserID: UserID,
            Flag: 'Return',
            token: token,
            handleIsPost,
            setloader: setloader,
        }
        // dispatch(ReceivedReturnPatchAPI({ data }))
    }

    // const { isloading } = useSelector(state => state.ReceivedReturnPatchData)

    return (
        <>
            <div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090" }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content p-3">
                        <div className="modal-header pt-0">

                            <h5 className="card-title fw-bold" id="exampleModalLongTitle">

                                {t('EncroachmentDashboard.Doyouwanttoreturnthecomplaint')}
                                {/* Forward */}
                            </h5>
                            <button onClick={() => handleReturn()} type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="row " >

                                    <div class="col-12 col-lg-6 pt-3">
                                        <ZoneNameCommanDDL
                                            ZoneNameID={ZoneNameID}
                                            setZoneNameID={setZoneNameID}
                                            Flag='Insert'
                                            ApiFlag='Master'
                                            data=''
                                            IsPost=''
                                            Language={Language}
                                        />
                                    </div>
                                    <div class="col-12 col-lg-6 pt-3">
                                        <WardNameDDL
                                            WardNameID={WardNameID}
                                            setWardNameID={setWardNameID}
                                            Flag='Insert'
                                            ApiFlag='Master'
                                            data=''
                                            IsPost=''
                                            Language={Language}
                                            ZoneNameID={ZoneNameID}
                                        />
                                    </div>
                                    <div class="col-12 col-lg-6 pt-3">
                                        <OfficerNameDDL
                                            OfficerNameID={OfficerNameID}
                                            setOfficerNameID={setOfficerNameID}
                                            Flag='Insert'
                                            ApiFlag="APK_Zonal"
                                            data=''
                                            IsPost=''
                                            Language={Language}
                                            ZoneNameID={ZoneNameID}
                                            WardNameID={WardNameID}
                                        />
                                    </div>
                                    <div class="col-12 col-lg-6 pt-3">
                                        <label for="fname" className=" pb-2">{t('EncroachmentDashboard.Remark')}</label><br />
                                        <input type="text"
                                            name="Remark"
                                            className="form-control"
                                            value={Remark}
                                            onChange={(e) => setRemark(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12 pt-3">
                                        <button
                                            type='button'
                                            onClick={() => handleAckData()}
                                            className="w-80 btn addbtn btn-success btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                            {/* <i class="fa-solid fa-floppy-disk pe-1"></i> */}
                                            {/* Forward */}
                                            {/* {t('EncroachmentDashboard.Forward')} */}
                                            Return
                                        </button>
                                        <button
                                            type="button"
                                            onClick={handleReturn}
                                            className="w-80  btn addbtn btn-danger btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                            <i class="fa-solid fa-xmark pe-1"></i> Cancel

                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>);
}

export default ReturnPopUp;